import { gql } from '../__generated__/gql'

export const CREATE_TENANT = gql(`
  mutation AdminCreateTenant(
    $id: String!,
    $name: String!,
    $fullAccessGrantObjects: AccessGrantObjectInput!,
    $trialAccessGrantObjects: AccessGrantObjectInput!,
    $previewAccessGrantObjects: AccessGrantObjectInput!,
    $supportEmail: String,
    $faqUrl: String,
    $extensionInstallUrl: String,
    $hasOauthLogin: Boolean,
    $hasEmailLogin: Boolean,
    $emailDeliveryMethod: EmailDeliveryMethod!,
    $emailCioAppApiKey: String,
    $emailCioTrackApiKey: String,
    $emailCioTrackSiteId: String,
    $emailCioWebhookSigningKey: String,
    $emailCioReportingWebhookSigningKey: String,
    $emailDeliveryWebhookUrl: String,
    $emailDeliveryWebhookRequestHeaders: JSONString,
    $emailDeliveryWebhookTimeout: Int,
  ) {
    adminCreateTenant(
      id: $id,
      name: $name,
      fullAccessGrantObjects: $fullAccessGrantObjects,
      trialAccessGrantObjects: $trialAccessGrantObjects,
      previewAccessGrantObjects: $previewAccessGrantObjects
      supportEmail: $supportEmail,
      faqUrl: $faqUrl,
      extensionInstallUrl: $extensionInstallUrl,
      hasOauthLogin: $hasOauthLogin,
      hasEmailLogin: $hasEmailLogin,
      emailDeliveryMethod: $emailDeliveryMethod,
      emailCioAppApiKey: $emailCioAppApiKey,
      emailCioTrackApiKey: $emailCioTrackApiKey,
      emailCioTrackSiteId: $emailCioTrackSiteId,
      emailCioWebhookSigningKey: $emailCioWebhookSigningKey,
      emailCioReportingWebhookSigningKey: $emailCioReportingWebhookSigningKey,
      emailDeliveryWebhookUrl: $emailDeliveryWebhookUrl,
      emailDeliveryWebhookRequestHeaders: $emailDeliveryWebhookRequestHeaders,
      emailDeliveryWebhookTimeout: $emailDeliveryWebhookTimeout,
    ) {
      statusCode
      error
      tenantId
    }
  }
`)

export const UPDATE_TENANT_EMAIL_CONFIG = gql(`
  mutation AdminUpdateTenantEmailConfig(
    $id: String!,
    $emailDeliveryMethod: EmailDeliveryMethod!,
    $emailCioAppApiKey: String,
    $emailCioTrackApiKey: String,
    $emailCioTrackSiteId: String,
    $emailCioWebhookSigningKey: String,
    $emailCioReportingWebhookSigningKey: String,
    $emailDeliveryWebhookUrl: String,
    $emailDeliveryWebhookRequestHeaders: JSONString,
    $emailDeliveryWebhookTimeout: Int,
  ) {
    adminUpdateTenantEmailConfig(
      id: $id,
      emailDeliveryMethod: $emailDeliveryMethod,
      emailCioAppApiKey: $emailCioAppApiKey,
      emailCioTrackApiKey: $emailCioTrackApiKey,
      emailCioTrackSiteId: $emailCioTrackSiteId,
      emailCioWebhookSigningKey: $emailCioWebhookSigningKey,
      emailCioReportingWebhookSigningKey: $emailCioReportingWebhookSigningKey,
      emailDeliveryWebhookUrl: $emailDeliveryWebhookUrl,
      emailDeliveryWebhookRequestHeaders: $emailDeliveryWebhookRequestHeaders,
      emailDeliveryWebhookTimeout: $emailDeliveryWebhookTimeout,
    ) {
      statusCode
      error
    }
  }
`)

export const CREATE_TENANT_OAUTH_CONFIG = gql(`
  mutation AdminCreateTenantOauthConfig(
    $name: String!
    $tenantId: String!
    $issuerUrl: String!
    $slug: String!
    $scope: [String!]!
    $clientId: String!
    $clientSecret: String!
    $isProduction: Boolean!
  ) {
    adminCreateTenantOauthConfig(
      name: $name
      tenantId: $tenantId
      issuerUrl: $issuerUrl
      slug: $slug
      scope: $scope
      clientId: $clientId
      clientSecret: $clientSecret
      isProduction: $isProduction
    ) {
      statusCode
      error
      configId
    }
  }
`)
